<template>
  <auth-guard
    route
  >
    <v-container>
      <url-breadcrumbs
        v-if="yard"
        :items="[
          ['yard list', { name: 'yard-list'}],
          yard.url
        ]"
      />
      <base-title v-if="!loading">
        {{ yard.name }}
      </base-title>
      <app-loading-indicator v-if="loading" />
      <div v-else>
        <v-toolbar
          flat
          dense
        >
          <user-upload-dialog
            :baseurl="`/api/yards/${yard.id}/`"
            :file-links="fileLinks"
          />
          <v-spacer />
          <write-call-notes
            :id="yard.id"
            @refetchYard="fetchRequirements"
          />
        </v-toolbar>
        <yard-info
          :statuses="statuses"
          :yard="yard"
          @updateYard="updateYardWrapper"
        />
        <v-row>
          <v-col
            cols="12"
          >
            <contact-info
              @updateYard="updateYardWrapper"
              :yard="yard"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <broker-terms
              :broker-terms="brokerageterm"
              @updateTerms="updateTerms"
              @addTerms="addTerms"
              @updated="fetchRequirements"
            />
          </v-col>
        </v-row>
        <yard-questions
          @updateYard="fetchRequirements"
          :yard="yard"
        />
        <br>
        <call-notes :call-notes="yard.call_notes" />
        <br>
        <yard-check-in-history :yard-check-ins="yardCheckIns" />
      </div>
    </v-container>
  </auth-guard>
</template>

<script>
import YardInfo from './Read/YardInfo'
import ContactInfo from './Read/ContactInfo'
import BrokerTerms from './Read/BrokerTerms'
import YardQuestions from './Read/YardQuestions'
import YardCheckInHistory from './Read/YardCheckInHistory'
import CallNotes from './Read/CallNotes'
import WriteCallNotes from './Write/WriteCallNotes'
import { mapGetters, mapActions } from 'vuex'
import UserUploadDialog from '@/base/components/UserUploadDialog.vue'
import fileLinks from '@/helpers/fileLinks'
import axios from 'axios'

export default {
  name: 'Yard',
  components: {
    UserUploadDialog,
    YardInfo,
    ContactInfo,
    BrokerTerms,
    YardQuestions,
    YardCheckInHistory,
    CallNotes,
    WriteCallNotes
  },
  data: () => ({
    loading: true,
    updatingHours: false,
    yardCheckIns: []
  }),
  methods: {
    ...mapActions('yardStore', [
      'fetchBrokerageTerms',
      'addBrokerageTerms',
      'updateBrokerageTerms',
      'fetchYard',
      'updateYard'
    ]),
    ...mapActions('checkIn', ['fetchCheckIns']),
    async fetchCheckIns () {
      const response = await axios.get(`/api/yards/${this.$route.params.id}/check_ins/`)
      if (response.data) {
        this.yardCheckIns = response.data
      }
      return response
    },
    /**
     * Get the yard after updates are completed
     * @return {Promise}
     */
    refetchYard () {
      return this.fetchYard(this.$route.params.id)
    },
    /**
     * Fetch all required entities for the page to load correctly. Set loading to false when done
     */
    async fetchRequirements () {
      await Promise.all([
        this.fetchYard(this.$route.params.id),
        this.fetchCheckIns()
      ])
      // load the brokerage terms
      if (this.$store.getters.can('api.view_brokerageterm') && this.yard.brokerageterm) {
        const url = (typeof this.yard.brokerageterm === 'string') ? this.yard.brokerageterm : this.yard.brokerageterm.url
        await this.fetchBrokerageTerms(url)
      } else {
        this.$store.commit('yardStore/setTerms', {})
      }
      this.loading = false
    },
    /**
     * Update information directly related to the yard
     * @param {Object} params
     */
    updateYardWrapper (params) {
      this.updateYard({ id: this.yard.id, params }).then(() => { this.refetchYard() })
    },
    /**
     * Update brokerage terms for the given yard
     * @param {Object} params
     */
    updateTerms (params) {
      if (!this.$store.getters.can('api.change_brokerageterm')) return
      params.yard = this.yard.url
      this.updateBrokerageTerms(params).then(() => { this.refetchYard() })
    },
    /**
     * Add brokerage terms to the given yard
     * @param {Object} params
     */
    addTerms (params) {
      if (!this.$store.getters.can('api.add_brokerageterm')) return
      params.yard = this.yard.url
      this.addBrokerageTerms(params).then(() => { this.refetchYard() })
    }
  },
  computed: {
    ...mapGetters({
      // yardCheckIns: 'checkIn/checkIns',
      yardDays: 'yardStore/yardDays',
      yard: 'yardStore/yard',
      statuses: 'businessStatuses',
      brokerageterm: 'yardStore/brokerageTerms'
    }),
    fileLinks () {
      return fileLinks.yardFileLink(this.yard)
    }
  },
  mounted () {
    this.fetchRequirements()
  }
}
</script>
